import React, { useEffect, useState } from 'react';
import { publicFetch } from '../utils/publicApi';
import { openBlankCoachTab, openCoachMode } from './deviceStore';

const API_BASE = process.env.REACT_APP_API_BASE || 'https://referee-roster-api-v2-hqghffesdfegd2dq.australiaeast-01.azurewebsites.net/api';

function formatTime(value) {
  if (!value) return '';
  const [h, m] = value.split(':').map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, '0')}${h >= 12 ? 'pm' : 'am'}`;
}

// Swish IQ trial days on a coach's My Portal Coach tab, for the week being
// viewed. "Launch coach mode" opens coach mode for that trial day in a new tab (the
// server only allows it on the day, from an hour before the start).
export default function PortalTrialSessions({ token, startDate, endDate }) {
  const [sessions, setSessions] = useState([]);
  const [busyId, setBusyId] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    publicFetch(`${API_BASE}/public/swishiq/portal/${token}/sessions`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : []))
      .then((rows) => { if (!cancelled) setSessions(Array.isArray(rows) ? rows : []); })
      .catch(() => { if (!cancelled) setSessions([]); });
    return () => { cancelled = true; };
  }, [token]);

  const inWeek = sessions.filter((s) => s.date >= startDate && s.date <= endDate);
  if (!inWeek.length) return null;

  async function launch(s) {
    const tab = openBlankCoachTab();
    setBusyId(s.subEventId);
    setError('');
    try {
      const res = await publicFetch(`${API_BASE}/public/swishiq/portal/${token}/unlock`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ subEventId: s.subEventId })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || `Couldn't open coach mode (HTTP ${res.status})`);
      openCoachMode(data, tab);
      setBusyId(null);
    } catch (e) {
      if (tab) tab.close();
      setError(e.message);
      setBusyId(null);
    }
  }

  return (
    <div style={{ marginBottom: '1.25rem' }}>
      <h3 style={{ margin: '0 0 0.5rem', fontSize: '1rem' }}>SwishIQ Trials sessions</h3>
      {error && (
        <div style={{ background: '#ffebee', border: '1px solid #ef9a9a', color: '#c62828', padding: '0.5rem 0.75rem', borderRadius: 6, marginBottom: '0.5rem', fontSize: '0.9rem' }}>
          {error}
        </div>
      )}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '0.75rem' }}>
        {inWeek.map((s) => (
          <div key={s.subEventId} style={{ border: '2px solid #a4161a', background: '#fff8f8', borderRadius: 10, padding: '0.75rem 0.9rem' }}>
            <div style={{ fontWeight: 700 }}>
              {s.eventName}{' '}
              <span style={{ background: '#ff66c4', color: '#fff', borderRadius: 4, fontSize: '0.65rem', fontWeight: 800, padding: '1px 6px', verticalAlign: 'middle' }}>TRIAL</span>
            </div>
            <div style={{ fontSize: '0.85rem', color: '#555', lineHeight: 1.5, marginTop: 4 }}>
              {new Date(`${s.date}T00:00:00`).toLocaleDateString('en-AU', { weekday: 'long', day: 'numeric', month: 'short' })}
              <br />
              Trial {s.dayNumber} of {s.dayCount} · {s.type} · {formatTime(s.startTime)}–{formatTime(s.endTime)}
              <br />
              {s.playerCount} players · {s.isHeadCoach ? 'Head coach' : 'Assistant coach'}
            </div>
            {s.canLaunchNow ? (
              <button
                type="button"
                onClick={() => launch(s)}
                disabled={busyId === s.subEventId}
                style={{ marginTop: '0.6rem', width: '100%', background: '#a4161a', color: '#fff', border: 'none', borderRadius: 8, padding: '0.6rem', fontWeight: 800, cursor: 'pointer' }}
              >
                {busyId === s.subEventId ? 'Opening…' : 'Launch coach mode →'}
              </button>
            ) : (
              <div style={{ marginTop: '0.6rem', textAlign: 'center', background: '#f4f4f5', color: '#777', borderRadius: 8, padding: '0.55rem', fontWeight: 600, fontSize: '0.85rem' }}>
                {new Date(s.closesAt) < new Date()
                  ? 'Trial day finished'
                  : `Coach mode opens ${new Date(s.opensAt).toLocaleString('en-AU', { weekday: 'short', hour: 'numeric', minute: '2-digit' })}`}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
